import React from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "../ui/sidebar";
import { Link, useLocation, useParams } from "react-router-dom";
import AppearanceToggle from "../Apperance";
import { ThemeToggle } from "../ThemeToggle";
import UserProfileButton from "./UserProfileButton";
import LogoSVG from "../LogoSVG";
import FaviconSVG from "../FaviconSVG";
import {
  BookOpenText,
  BookUser,
  Building,
  ChartArea,
  ClipboardCheckIcon,
  FileText,
  GraduationCapIcon,
  Home,
  Landmark,
  NotebookPen,
  Settings,
  ShieldCheckIcon,
  TicketsIcon,
  User,
  UserRoundCheckIcon,
  Wallet,
} from "lucide-react";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { useUser } from "../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../lib/PermissionConditions";

const MainSidebar = ({ props }) => {
  const params = useParams();
  const trustId = params?.trust_id;
  const roleType = localStorage.getItem("roleType");
  const { organizationData } = useOrganization();
  const { userData } = -useUser();

  const location = useLocation();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  let items =
    roleType !== "Admin"
      ? trustId
        ? [
            {
              title: "Trust Dashboard",
              url: `/trusts/${trustId}/dashboard`,
              icon: ChartArea,
            },
            {
              title: "Receipts",
              url: `/trusts/${trustId}/receipts`,
              icon: FileText,
            },
            {
              title: "Payments",
              url: `/trusts/${trustId}/payments`,
              icon: Wallet,
            },
            {
              title: "Payment Instructions",
              url: `/trusts/${trustId}/abas`,
              icon: NotebookPen,
            },
            {
              title: "Bank Reconciliation",
              url: `/trusts/${trustId}/banking`,
              icon: Landmark,
            },
            {
              title: "Trust Settings",
              url: `/trusts/${trustId}/trust-general-settings`,
              icon: Settings,
            },
          ]
        : organizationData?.organizationData?.is_subscribed
          ? [
              {
                title: "Trust",
                url: "/trusts",
                icon: Home,
              },
              {
                title: "Users",
                url: "/users",
                icon: User,
              },
              {
                title: "Offices",
                url: "/offices",
                icon: Building,
              },
              {
                title: "Support Ticket",
                url: "/support-tickets",
                icon: TicketsIcon,
              },
              {
                title: "Entity Settings",
                url: "/general-settings",
                icon: Settings,
              },
            ]
          : organizationData?.organizationData?.is_aml_ctf_subscribed ? [
              {
                title: "Risk Assessments",
                url: "/aml-ctf?tab=program",
                icon: Home,
              },
              // {
              //   title: "Support Ticket",
              //   url: "/support-tickets",
              //   icon: TicketsIcon,
              // },
              {
                title: "Settings",
                url: "/general-settings",
                icon: Settings,
              },
            ] : [
              {
                title: "Trust",
                url: "/trusts",
                icon: Home,
              },
              // {
              //   title: "Support Ticket",
              //   url: "/support-tickets",
              //   icon: TicketsIcon,
              // },
              {
                title: "Settings",
                url: "/general-settings",
                icon: Settings,
              },
            ]
      : [
          {
            title: "Dashboard",
            url: "/admin-dashboard",
            icon: Home,
          },
          {
            title: "Registered",
            url: "/registered-users",
            icon: UserRoundCheckIcon,
          },
          {
            title: "Roles",
            url: "/admin-roles",
            icon: BookUser,
          },
          {
            title: "Users",
            url: "/admin-users",
            icon: User,
          },
          {
            title: "Support Ticket",
            url: "/admin/support-tickets",
            icon: TicketsIcon,
          },
        ];

  if (!trustId && roleType !== "Admin" && amlCTFEnable) {
    let amlCtfItems = [
      {
        title: "Governance",
        url: "/aml-ctf?tab=governance-framework",
        icon: Landmark,
      },
      {
        title: "Program",
        url: "/aml-ctf?tab=program",
        icon: BookOpenText,
      },
      {
        title: "Training",
        url: "/aml-ctf?tab=training",
        icon: GraduationCapIcon,
      },
      {
        title: "CDD",
        url: "/aml-ctf?tab=cdd",
        icon: ClipboardCheckIcon,
      },
      {
        title: "Report Activities",
        url: "/aml-ctf?tab=incidents",
        icon: ShieldCheckIcon,
      },
    ];
    items = [...items, ...amlCtfItems];
  }

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenuButton
          size="lg"
          className="p-0 h-fit data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground group-data-[collapsible=icon]:!h-11"
        >
          <Link
            to={roleType === "Admin" ? `/admin-dashboard` : "/trusts"}
            className="flex items-center gap-2 text-lg font-semibold md:text-base"
          >
            {/* <img
              src={favLogo}
              width="32"
              height="60"
              alt="Logo TrustSoft"
              style={{
                maxHeight: 60,
                width: "100%",
              }}
              className="group-data-[state=expanded]:hidden"
            /> */}
            <FaviconSVG className="group-data-[state=expanded]:hidden group-data-[mobile=true]:hidden w-9 h-16 !text-webPrimary !fill-webPrimary" />

            <LogoSVG className="group-data-[state=collapsed]:hidden !text-webPrimary !fill-webPrimary h-16 w-full" />
          </Link>
        </SidebarMenuButton>
      </SidebarHeader>
      <SidebarContent>
        {/* <SidebarGroup> */}
        <SidebarMenu>
          {items.map((item) => {
            const isActive =
              item?.url === "/trusts"
                ? location.pathname === item?.url
                : location.pathname?.includes(item.url);
            return (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton
                  asChild
                  data-active={isActive ? true : false}
                  className={`${
                    isActive ? "bg-webPrimary text-white" : "hover:bg-muted "
                  }`}
                  title={item.title}
                >
                  <Link to={item.url}>
                    <item.icon />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
        {/* </SidebarGroup> */}
      </SidebarContent>
      <SidebarFooter>
        <SidebarMenuButton
          size="lg"
          className="p-0 h-fit data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <AppearanceToggle />
        </SidebarMenuButton>
        <SidebarMenuButton
          size="lg"
          className="p-0 h-fit data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
        >
          <ThemeToggle side={true} />
        </SidebarMenuButton>

        <UserProfileButton />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
};

export default MainSidebar;
